import { render, staticRenderFns } from "./CustomerWifiAccess.vue?vue&type=template&id=27f72268&scoped=true"
import script from "./CustomerWifiAccess.vue?vue&type=script&lang=js"
export * from "./CustomerWifiAccess.vue?vue&type=script&lang=js"
import style0 from "./CustomerWifiAccess.vue?vue&type=style&index=0&id=27f72268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f72268",
  null
  
)

export default component.exports